// WP-0.7 (§18.1): the centered card that hosts Setup/Login (both are "centered card"
// layouts per S-01/S-02). Standalone — no app chrome. First screen the owner ever sees,
// so it carries the one branded moment in an otherwise chrome-first app.
import { Mark } from './Mark';

export function AuthCard({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <div className="flex min-h-full items-center justify-center bg-bg p-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center justify-center gap-2">
          <Mark size={22} />
          <span className="text-sm font-medium tracking-wide text-muted">PF-OS</span>
        </div>
        <div className="rounded-[var(--radius-card)] border border-border bg-surface p-6">
          <h1 className="mb-1 text-2xl font-semibold text-ink">{title}</h1>
          {subtitle !== undefined && <p className="mb-5 text-sm text-muted">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
}
